import { render } from "./gxbsy.vue?vue&type=template&id=0a6c644d"
import script from "./gxbsy.vue?vue&type=script&lang=js"
export * from "./gxbsy.vue?vue&type=script&lang=js"

import "./gxbsy.vue?vue&type=style&index=0&id=0a6c644d&lang=css"

import exportComponent from "C:\\huishan\\项目\\20250520 辉山官网\\源码\\官网-前端\\huishan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__